import type { ExtractPropTypes } from "vue";

import type MonitorPlayback from "./monitor-playback.vue";

export const MonitorPlaybackProps = {
  /**
   * 视频地址
   */
  url: {
    type: String,
    default: "",
  },
  /**
   * 访问令牌
   */
  accessToken: {
    type: String,
    default: "",
  },
  /**
   * 视频标题
   */
  areaName: {
    type: String,
    default: "",
  },
  /**
   * 视频ID
   */
  deviceSerial: {
    type: String,
    default: "",
  },
  /**
   * 视频平台类型名称
   */
  platformTypeName: {
    type: String,
    default: "",
  },
  debug: {
    type: Boolean,
    default: false,
  },
};

export type MonitorPlaybackPropsType = ExtractPropTypes<
  typeof MonitorPlaybackProps
>;
export type MonitorPlaybackInstance = InstanceType<typeof MonitorPlayback>;
